import Icon from '@/components/ui/AppIcon';

interface BusinessHour {
  day: string;
  hours: string;
  isToday?: boolean;
}

interface EmailContact {
  address: string;
  note?: string;
}

interface BusinessHoursProps {
  hours: BusinessHour[];
  responseTime: string;
  emailContact?: EmailContact;
}

const BusinessHours = ({ hours, responseTime, emailContact }: BusinessHoursProps) => {
  return (
    <div className="bg-card rounded-[2rem] shadow-soft p-8 border border-border">
      <h3 className="font-heading font-bold text-lg mb-6">Waktu Operasi</h3>

      <ul className="space-y-4 mb-8">
        {hours.map((item, index) => (
          <li key={index} className="flex items-center justify-between text-sm">
            <span className="text-textSecondary">{item.day}</span>
            <span className={`${item.isToday ? 'text-primary font-bold' : 'font-bold'}`}>
              {item.hours}
            </span>
          </li>
        ))}
      </ul>

      <div className="mt-2">
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="InformationCircleIcon" size={20} variant="solid" className="text-primary" />
            <div>
              <p className="text-sm font-body font-semibold text-textPrimary mb-1">Masa Respons</p>
              <p className="text-sm font-body text-textSecondary">{responseTime}</p>
            </div>
          </div>
        </div>
      </div>

      {emailContact && (
        <div className="mt-8 pt-8 border-t border-border">
          <h5 className="font-heading font-bold text-lg mb-4">Emel Pertanyaan</h5>
          <div className="flex items-center gap-3 text-primary">
            <Icon name="EnvelopeIcon" size={20} variant="outline" />
            <a
              className="font-cta font-bold hover:underline"
              href={`mailto:${emailContact.address}`}
            >
              {emailContact.address}
            </a>
          </div>
          {emailContact.note && (
            <p className="text-xs text-textTertiary mt-2">{emailContact.note}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default BusinessHours;
